import { memo } from "react";
import Link from "next/link";
import { Router } from "next/router";

import ChevronIcon from "components/Icons/ChevronIcon";

type Props = {
  page: number;
  total: number;
  setPage: (value: number) => void;
  getUrl: (page: number) => Router;
};

const Pagination = memo(({ page, total, setPage, getUrl }: Props) => {
  const prevPage = page - 1;
  const nextPage = page + 1;

  return (
    <div className="flex flex-row text-sm py-xl">
      <div className="flex justify-start col-4">
        {page > 1 && (
          <Link
            href={getUrl(prevPage)}
            className="flex flex-row items-center font-bold text-green"
            onClick={(event) => {
              event.preventDefault();
              setPage(prevPage);
            }}
            data-testid="previous-page-button"
          >
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- TODO: fix me, do not replicate */}

            <ChevronIcon height="12" width="12" direction="left" />
            <span className="ml-xs">Prev</span>
          </Link>
        )}
      </div>
      <div className="flex justify-center col-4" data-testid="page-count">
        {page} of {total}
      </div>
      <div className="flex justify-end col-4">
        {page < total && (
          <Link
            href={getUrl(nextPage)}
            className="flex flex-row items-center font-bold text-green"
            onClick={(event) => {
              event.preventDefault();
              setPage(nextPage);
            }}
            data-testid="next-page-button"
          >
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions -- TODO: fix me, do not replicate */}

            <span className="mr-xs">Next</span>
            <ChevronIcon height="12" width="12" direction="right" />
          </Link>
        )}
      </div>
    </div>
  );
});

export default Pagination;
